const Bag = ({ width, height = 'h-auto' }) => {
    return (
        <div className={`bag-icon ${width} ${height}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                color="currentColor"
                fill="none"
                viewBox="0 0 20 21"
            >
                <path
                    fill="#231F20"
                    d="M16.875 5.5H13.75a3.75 3.75 0 0 0-7.5 0H3.125a1.25 1.25 0 0 0-1.25 1.25v9.375a1.25 1.25 0 0 0 1.25 1.25h13.75a1.25 1.25 0 0 0 1.25-1.25V6.75a1.25 1.25 0 0 0-1.25-1.25M10 3a2.5 2.5 0 0 1 2.5 2.5h-5A2.5 2.5 0 0 1 10 3m6.875 13.125H3.125V6.75H6.25V8A.625.625 0 0 0 7.5 8V6.75h5V8a.625.625 0 1 0 1.25 0V6.75h3.125z"
                ></path>
            </svg>
        </div>
    )
}

export default Bag
